import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M6.125 10.5V3.369L3.85 5.644 2.625 4.375 7 0l4.375 4.375-1.225 1.269-2.275-2.275V10.5zM1.75 14q-.722 0-1.235-.514A1.7 1.7 0 0 1 0 12.25V9.625h1.75v2.625h10.5V9.625H14v2.625q0 .721-.514 1.236A1.68 1.68 0 0 1 12.25 14z"
    }, null, -1)
  ]))]))
}
export default { render: render }